import React from "react";
import { makeStyles, Grid, useMediaQuery, useTheme } from "@material-ui/core";

import { withTranslation } from "react-i18next";
import MainImgComponent from "../../../components/MainComponent/FirstSectionComponent/MainImgComponent";

const useStyles = makeStyles((theme) => ({
  bgSect: {
    minHeight: "100vh",
    backgroundImage: " url(images/main/test3.jpg)",

    // width: "100%",
    backgroundSize: "cover",
    background: "no-repeat",
    willChange: "transform",
    [theme.breakpoints.down("xs")]: {
      
    },
  },
}));

interface FirstSectionProps {
  children: React.ReactNode | null | string | undefined;
}

function FirstSection() {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <Grid
      xs={12}
      item
      container
      alignItems="center"
      justify="center"
      className={classes.bgSect}
    >
      {/* <SwiperSlider /> */}
      <MainImgComponent />
    </Grid>
  );
}

// export default MainContainer;
export default withTranslation()(FirstSection);
